import {
  I_CallToActionConfigGlobal,
  I_FormCaptureConfigGlobal,
  I_ConfigThemeDefaultNew,
  I_CollaborationConfig,
  I_ConfigThemeDefault,
  I_ConfigThemeCustom1,
  I_ConfigScenePlugin,
  I_ControlbarConfig,
  I_FloorplanConfig,
  I_LogoConfig,
  I_MapConfig,
  I_Tenant,
  I_CopyRightConfig,
  I_ConfigThemeCustom2,
  I_ConfigThemeCustom3,
  I_HotspotConfig,
} from './types';

export const LIST_TRANSITION_SCENES = [
  { label: 'none', value: 'NOBLEND' },
  { label: '3d transition', value: '3d' },
  { label: 'simple crossblending', value: 'BLEND(1.0, easeInCubic)' },
  { label: 'zoom blend', value: 'ZOOMBLEND(2.0, 2.0, easeInOutSine)' },
  { label: 'black-out', value: 'COLORBLEND(2.0, 0x000000, easeOutSine)' },
  { label: 'white-flash', value: 'LIGHTBLEND(1.0, 0xFFFFFF, 2.0, linear)' },
  { label: 'right-to-left', value: 'SLIDEBLEND(1.0, 0.0, 0.2, linear)' },
  { label: 'top-to-bottom', value: 'SLIDEBLEND(1.0, 90.0, 0.01, linear)' },
  { label: 'diagonal', value: 'SLIDEBLEND(1.0, 135.0, 0.4, linear)' },
  { label: 'circle open', value: 'OPENBLEND(1.0, 0.0, 0.2, 0.0, linear)' },
  { label: 'vertical open', value: 'OPENBLEND(0.7, 1.0, 0.1, 0.0, linear)' },
  { label: 'horizontal open', value: 'OPENBLEND(1.0, -1.0, 0.3, 0.0, linear)' },
  { label: 'elliptic + zoom', value: 'OPENBLEND(1.0, -0.5, 0.3, 0.8, linear)' },
] as const;

// time pause when user interact on screen
export const TIME_DELAY_PAUSE_AUTOPLAYSCENE = 5;

export const CONFIG_THEME_COLOR_DEFAULT: {
  default: I_ConfigThemeDefault['config'];
  defaultNew: I_ConfigThemeDefaultNew['config'];
  custom1: I_ConfigThemeCustom1['config'];
  custom2: I_ConfigThemeCustom2['config']; // Agaya Theme
  custom3: I_ConfigThemeCustom3['config']; // Nachi Theme
} = {
  default: {
    primaryColor: '#fff',
    textColor: '#000000',
  },
  defaultNew: {
    primaryColor: '#fff',
    textColor: '#000000',
  },
  custom1: {
    primaryColor: '#D3015B',
    secondaryColor: '#F7C003',
    textColor: '#fff',
  },
  custom2: {
    // Agaya Theme
    primaryColor: '#D3015B',
    textColor: '#fff',
  },
  custom3: {
    // Nachi Theme
    primaryColor: '#D3015B',
    textColor: '#fff',
  },
} as const;

export const CONFIG_POLYGON_HOTSPOT_DEFAULT = {
  fillColor: '#ffffff20',
  fillColorHover: '#ffffff50',
  borderWidth: 3,
  borderColor: '#ffffff',
  borderColorHover: '#ffffff',
} as const;

export const DEFAULT_VALUE_COPYRIGHT_CONFIG: I_CopyRightConfig = {
  isEnabled: true,
  link: '',
  author: 'Powered by',
  logo: '',
};

export const DEFAULT_VALUE_FLOORPLAN_CONFIG: I_FloorplanConfig = {
  isShowOnStart: false,
  bgColor: '#ffffff75',
  floorplan: {
    type: 'panel',
    position: 'left',
  },
  marker: {
    bgColor: '#007afe',
    borderColor: '#fff',
  },
  radar: {
    isEnabled: false,
    bgColor: '#007afe40',
    borderColor: '#007afebf',
    borderWidth: 1,
    width: 48,
  },
} as const;

export const DEFAULT_VALUE_MAP_CONFIG: I_MapConfig = {
  isEnabled: false,
  isShowOnStart: false,
  mapStyle: '',
  mapType: 'roadmap',
  map: {
    type: 'panel',
    position: 'left',
  },
  marker: {
    src: '',
  },
  radar: {
    isEnabled: false,
    bgColor: '#007afe40',
    borderColor: '#007afebf',
    borderWidth: 1,
    width: 48,
  },
} as const;

export const DEFAULT_VALUE_LOGO_CONFIG: I_LogoConfig = {
  isEnabled: false,
  image: '',
  url: '',
  size: 180,
  position: 'topLeft',
} as const;

export const COLOR_HOTSPOT_BG_DEFAULT = '#E54D42';
export const COLOR_HOTSPOT_ICON_DEFAULT = '#fff';

export const COLOR_POPUP_BG_DEFAULT = '#ffffff';
export const COLOR_POPUP_TEXT_DEFAULT = '#000000';

export const BG_COLOR_DOLLHOUSE_DEFAULT = '#000000';
export const HOTSPOT_COLOR_DOLLHOUSE_DEFAULT = '#ffffff';

export const DEFAULT_HOTSPOT_CONFIG: I_HotspotConfig = {
  style: {
    type: 'icon',
    effect: 'normal',
    rotate: 0,
    opacity: 100,
    size: 3,
    // Default box-shadow values
    boxShadowX: 0,
    boxShadowY: 0,
    boxShadowSpread: 2,
    boxShadowBlur: 5,
    boxShadowColor: 'rgba(0,0,0,0.25)',
    image: {},
    point: {},
    icon: {},
    lottie: { loop: true },
    marker: {},
    callout: { type: 'image', degrees: 45 },
  },
};

export const DEFAULT_CONFIG_SCENE_PLUGIN: I_ConfigScenePlugin = {
  pp_light: {
    enabled: false,
    exposure: 0,
    lights: 0,
    shadows: 0,
    filterrange: 60,
    masking: 1,
    quality: 7,
  },
  pp_sharpen: {
    enabled: false,
    strength: 0,
    quality: 5,
    range: 1.5,
  },
  lensflare: {
    enabled: false,
    exposure_bias: -1,
    sun: 0.5,
    glare: 0.2,
    r_ring: 0.25,
    ath: 0,
    atv: 0,
  },
  floorplan: {
    hide: false,
  },
} as const;

export const DEFAULT_CONFIG_INSTRUCTOR_HOTSPOT = {
  width: 150,
  height: 300,
  smoothing: 0.294,
  threshold: 0.133,
  volume: 1,
  loop: true,
  paused_on_start: true,
  media: undefined,
  sound_360: true,
  mask: '#238E54' as const,
} as const;

export const CONFIG_FORM_CAPTURE_DEFAULT: I_FormCaptureConfigGlobal = {
  backgroundColor: '#fff',
  overlayColor: '#00000073',
  layout: {
    type: 'dialog',
  },
} as const;

export const CONFIG_CALL_TO_ACTION_DEFAULT: I_CallToActionConfigGlobal = {
  layout: 'list',
  position: 'left',
  offsetLeft: '12',
  offsetRight: '12',
  offsetBottom: '165',
} as const;

export const LIST_FAVICON_DEFAULT = [
  {
    rel: 'shortcut icon',
    href: `${process.env.NEXT_PUBLIC_ASSETS_URL}/static/favicon.png`,
  },
  {
    rel: 'apple-touch-icon',
    href: `${process.env.NEXT_PUBLIC_ASSETS_URL}/static/favicon_60.png`,
    sizes: '60x60',
  },
  {
    rel: 'apple-touch-icon',
    href: `${process.env.NEXT_PUBLIC_ASSETS_URL}/static/favicon_76.png`,
    sizes: '76x76',
  },
  {
    rel: 'apple-touch-icon',
    href: `${process.env.NEXT_PUBLIC_ASSETS_URL}/static/favicon_120.png`,
    sizes: '120x120',
  },
  {
    rel: 'apple-touch-icon',
    href: `${process.env.NEXT_PUBLIC_ASSETS_URL}/static/favicon_152.png`,
    sizes: '152x152',
  },
];

export const LIST_LINK_STYLE_SHEET = [
  {
    rel: 'manifest',
    href: `/manifest.json`,
  },
];

export const DEFAULT_VALUE_COLLABORATION_CONFIG: I_CollaborationConfig = {
  isEnabled: false,
  isPublic: true,
  collaborations: '',
} as const;

export const DEFAULT_VALUE_CONTROLBAR_CONFIG: I_ControlbarConfig = {
  floorplan: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-layer-group',
  },
  sound_project_on: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-volume',
  },
  sound_project_off: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-volume-mute',
  },
  auto_rotate_on: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-repeat',
  },
  auto_rotate_off: {
    isHide: false,
    type: 'icon',
    icon: 'fal fa-repeat',
  },
  home: { isHide: false, type: 'icon', icon: 'far fa-home' },
  auto_change_scene_on: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-pause',
  },
  auto_change_scene_off: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-play',
  },
  sound_scene_on: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-volume-up',
  },
  sound_scene_off: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-volume-off',
  },
  view_mode: { isHide: false, type: 'icon', icon: 'far fa-eye' },
  multi_staging: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-images',
  },
  gyro: { isHide: false, type: 'icon', icon: 'far fa-hurricane' },
  vr: { isHide: false, type: 'icon', icon: 'far fa-head-vr' },
  fullscreen: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-expand-arrows-alt',
  },
  map: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-map-marked-alt',
  },
  info_scene: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-info',
  },
  info_tour: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-file-alt',
  },
  group_auto_play: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-play',
  },
  view_mode_normal: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-mountains',
  },
  view_mode_little_planet: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-globe-asia',
  },
  view_mode_mirror: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-globe',
  },
  screenshot_capture: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-camera-viewfinder',
  },
  multi_language: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-language',
  },
  dollhouse: {
    isHide: false,
    type: 'icon',
    icon: 'far fa-kaaba',
  },
} as const;

export const ID_KRPANO_CONTAINER = 'krpanoViewSnapshot';

export const TENANT_DEFAULT: I_Tenant = {
  title: 'Lushlist | The Smart Virtual Tour Software for everyone',
  description:
    'Start free to build high-quanlity &amp; smart 360° Virtual Tour in minutes with beautiful themes &amp; unlimited customization.',
  name: 'Lushlist Tour',
  domain_public: process.env.NEXT_PUBLIC_BASE_URL,
  domain_studio: process.env.NEXT_PUBLIC_BASE_URL_STUDIO,
  seoImage: {
    name: 'Cover',
    type: 'asset',
    mimetype: 'image/jpeg',
    size: 102833,
    isFolder: false,
    updated_at: '2023-06-06T16:08:29.789Z',
    created_at: '2023-06-06T16:08:25.772Z',
    src_thumb: '/images/panoee-cover.jpg',
    src_preview: '/images/panoee-cover.jpg',
    krpano_xml: '',
    id: '647f59f9bcf0da66ac6b0d6d',
    src: '/images/panoee-cover.jpg',
  },
  logo: {
    name: 'Cover',
    type: 'asset',
    mimetype: 'image/jpeg',
    size: 102833,
    isFolder: false,
    updated_at: '2023-06-06T16:08:29.789Z',
    created_at: '2023-06-06T16:08:25.772Z',
    src_thumb: '/images/logo.png',
    src_preview: '/images/logo.png',
    krpano_xml: '',
    id: '647f59f9bcf0da66ac6b0d6d',
    src: '/images/logo.png',
  },
  favicon: {
    name: 'Favicon',
    type: 'asset',
    mimetype: 'image/jpeg',
    size: 102833,
    isFolder: false,
    updated_at: '2023-06-06T16:08:29.789Z',
    created_at: '2023-06-06T16:08:25.772Z',
    src_thumb: `${process.env.NEXT_PUBLIC_ASSETS_URL}/static/favicon.png`,
    src_preview: `${process.env.NEXT_PUBLIC_ASSETS_URL}/static/favicon.png`,
    krpano_xml: '',
    id: '647f59f9bcf0da66ac6b0d6d',
    src: `${process.env.NEXT_PUBLIC_ASSETS_URL}/static/favicon.png`,
  },
  color_primary: '#55b4ea',
  config: {
    copyright: DEFAULT_VALUE_COPYRIGHT_CONFIG,
  },
};
